import React, { useMemo, useState } from "react";
import { useTable } from "react-table";
import axios from "axios";
import * as XLSX from "xlsx";

import {
  clearCheckedLists,
  AddOptionToString,
  isNull,
} from "../../../components/common/Common";
import SalesNoteDetail from "./SalesNoteDetail";

function SalesSearchResult({
  varColumnLists,
  varTotalCount,
  varPageNum,
  varMaxNumPage,
  varSalesList,
  setSalesList,
  isVehicleNumberMode,
  varPageSize,
  setPageSize,
  excelData,
}) {
  let admin_idx = 0;
  if (!isNull(localStorage.getItem("adminIdx")))
    admin_idx = Number(localStorage.getItem("adminIdx"));

  const [varExcelProgress, setExcelProgress] = useState(false);
  const [varDeliveryIndex, setDeliveryIndex] = useState(0);
  const [varShowDeliveryDetail, setShowDeliveryDetail] = useState(false);
  const [memberId, setMemberId] = useState(0);
  const [deliveryName, setDeliveryName] = useState("");

  const columns = useMemo(() => {
    return varColumnLists;
  }, [varColumnLists]);

  const data = useMemo(() => {
    return varSalesList;
  }, [varSalesList]);

  const hiddenColumns = useMemo(() => {
    const columnsToHide = ["data7", "data8", "data9"];
    if (!isVehicleNumberMode) {
      columnsToHide.push("data2"); // Include data2 when isVehicleNumberMode is false
    }
    return columnsToHide;
  }, [isVehicleNumberMode]);

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({
      columns,
      data,
      initialState: { hiddenColumns },
    });

  const onCheckedAll = (e) => {
    const bChecked = Number(e.currentTarget.checked);
    clearCheckedLists(bChecked);
    let copyDatas = [...varSalesList];
    for (var i = 0; i < copyDatas.length; i++) {
      copyDatas[i].data7 = bChecked;
    }
    setSalesList(copyDatas);
  };

  const onCheckedElement = (e, cs_idx) => {
    const bChecked = Number(e.currentTarget.checked);
    const findIndex = varSalesList.findIndex(
      (element) => element.data8 === cs_idx
    );
    let copyLists = [...varSalesList];
    copyLists[findIndex].data7 = bChecked;
    setSalesList(copyLists);
    CheckAllButtonState();
  };

  const CheckAllButtonState = () => {
    let bchecked = true;
    const delItems = document.querySelectorAll(".del-item");
    for (var i = 0; i < delItems.length; i++) {
      if (delItems[i].checked === false) {
        bchecked = false;
        break;
      }
    }
    const chkallItem = document.getElementById("deleteItems");
    chkallItem.checked = bchecked;
  };

  const onDownloadExcelHandler = () => {
    if (!window.confirm("Excel 파일로 다운로드합니까?")) return;

    let excelList = [];

    // excelData에 있는 데이터를 다운로드할 리스트에 추가
    if (excelData.length > 0) {
      excelList = excelData.map((item, index) => {
        const newExcelObj = { 번호: index + 1 }; // 번호 추가
        varColumnLists.forEach((column) => {
          if (
            column.accessor !== "data9" &&
            column.accessor !== "data7" && // 선택유무 컬럼 제외
            column.accessor !== "data8" && // id 컬럼 제외
            (isVehicleNumberMode || column.accessor !== "data2") // 조건에 따른 제외
          ) {
            newExcelObj[column.Header] = item[column.accessor] || "";
          }
        });
        return newExcelObj;
      });
    } else {
      alert("다운로드할 데이터가 없습니다.");
      return;
    }

    const ws = XLSX.utils.json_to_sheet(excelList);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "매출현황");
    XLSX.writeFileXLSX(wb, "매출현황.xlsx");

    // Reset the checkboxes after downloading the Excel file
    const resetSalesList = varSalesList.map((row) => ({
      ...row,
      data7: 0,
    }));
    setSalesList(resetSalesList);
    clearCheckedLists(false); // This should also clear the checkbox state
  };

  const onChangePageSizeHandler = (e) => {
    setPageSize(Number(e.currentTarget.value));
  };

  const onOpenDeliveryDetail = (e, dc_idx) => {
    setDeliveryIndex(dc_idx);
    setShowDeliveryDetail(true);
  };

  return (
    <>
      <div className="main-box" style={{ marginTop: "30px" }}>
        <div className="btn-between">
          <div>
            {varExcelProgress ? (
              <span style={{ marginLeft: "20px" }}>작업중...</span>
            ) : null}
          </div>
          <div>
            <span>검색건수 : {varTotalCount} 건</span>&nbsp;&nbsp;
            <select
              name="pageSize"
              value={varPageSize}
              style={{ width: "120px" }}
              onChange={onChangePageSizeHandler}
            >
              <option value={0}>전체</option>
              <option value={100}>100</option>
              <option value={500}>500</option>
              <option value={1000}>1000</option>
            </select>
            <button
              onClick={(e) => onDownloadExcelHandler(e)}
              className="btn line"
            >
              EXCEL 다운로드
            </button>
          </div>
        </div>
        <div className="scroll-table">
          <table className="list scroll delivery" {...getTableProps()}>
            <thead>
              {headerGroups?.map((headerGroup, y) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  <th style={{ width: "30px" }}>
                    <input
                      type="checkbox"
                      style={{ marginLeft: "0px" }}
                      id="deleteItems"
                      onChange={(e) => onCheckedAll(e)}
                    />
                  </th>
                  <th style={{ width: "50px" }}>번호</th>
                  {headerGroup?.headers?.map((column) => (
                    <th
                      {...column.getHeaderProps({
                        style: { width: column.width },
                      })}
                    >
                      {column.render("Header")}
                    </th>
                  ))}
                  <th style={{ width: "90px" }}></th>
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {varSalesList?.length === 0 ? (
                <tr>
                  <td colSpan={13}>매출현황이 없습니다.</td>
                </tr>
              ) : (
                rows?.map((row, i) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      <td className="board-list">
                        <input
                          type="checkbox"
                          className={"del-item"}
                          id={"deleteItem_"}
                          onChange={(e) =>
                            onCheckedElement(e, row.values.data8)
                          }
                        />
                      </td>
                      <td>{i + 1 + (varPageNum - 1) * varPageSize}</td>
                      {row?.cells?.map((cell, i) => {
                        return (
                          <td
                            {...cell.getCellProps({
                              style: { width: cell.column.width },
                            })}
                          >
                            {cell.render("Cell")}
                          </td>
                        );
                      })}
                      <td>
                        <button
                          className="btn line black"
                          onClick={(e) => {
                            setMemberId(row.values.data9);
                            setDeliveryName(row.values.data2);
                            onOpenDeliveryDetail(e, row.values.data24);
                          }}
                        >
                          정산 메모
                        </button>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
        <SalesNoteDetail
          varDeliveryIndex={varDeliveryIndex}
          setDeliveryIndex={setDeliveryIndex}
          varDeliveryLists={varSalesList}
          memberId={memberId}
          deliveryName={deliveryName}
          // setDeliveryLists={setDeliveryLists}
          varShowDeliveryDetail={varShowDeliveryDetail}
          setShowDeliveryDetail={setShowDeliveryDetail}
        />
      </div>
    </>
  );
}

export default SalesSearchResult;
